<script>
/* eslint-disable */
import GoogleMapsApiLoader from 'google-maps-api-loader'
import {checkRouteStatus, getLocations, getTickets, saveRoute, snapToRoads} from '../../../domain/callcenter/services'
import ContextMenu from '../../map/mixins/ContextMenu'
import Geocode from '../../map/mixins/Geocode'

let numDeltas = 100;
let delay = 10; //milliseconds
let transitionIndex = 0;
let deltaLat;
let deltaLng;

export default {
  name: 'CallCenterMap',
  props: ['reboques'],
  mixins: [ContextMenu, Geocode],
  data () {
    return {
      apiKey: 'AIzaSyBDcOX95zh5XaUJgY5ZXyQrB6o8fRxx5rQ',
      mapOptions: {
        zoom: 8,
        center: {lat: -20.420874, lng: -40.329344}
      },
      google: null,
      map: null,
      markers: null,
      places: [],
      currentPlace: null,
      snappedCoordinates: null,
      placeIdArray: null,
      polylines: [],
      reboquesDisponiveis: [],
      instanceIds: [], // Reboques instanciados com o Marker
      activeRoutes: [] // Rotas ativas
    };
  },
  async mounted () {
    this.geolocate();

    const googleMapApi = await GoogleMapsApiLoader({
      apiKey: this.apiKey
    })
    this.google = googleMapApi
    this.initializeMap()
    this.$intervalFocusMarker = setInterval(() => { // TODO: Temporário. Deve existir uma função ativa por uma prop para navegar automatico entre os pontos (markers)
      console.log('Pan to: ', this.reboquesDisponiveis)
      if (Array.isArray(this.reboquesDisponiveis) && this.reboquesDisponiveis.length === 1) {
        this.map.panTo(this.reboquesDisponiveis[0].marker.position)
      }
    }, 10000)
  },
  destroyed () {
    clearInterval(this.$intervalFocusMarker)
  },
  watch: {
    reboques () {
      setTimeout(() => {
        this.removeGhosts()
        this.loadReboques()
      }, 2000)
    }
  },
  methods: {
    initializeMap () {
      const mapContainer = this.$refs.googleMap
      this.map = new this.google.maps.Map(
        mapContainer, this.mapOptions
      )
      this.google.maps.event.addListener(this.map, 'rightclick', (event) => {
        this.showContextMenu(event.latLng);
      })

      // Geocoder
      this.geocoder = new this.google.maps.Geocoder();

      // MaxZoom
      this.maxZoomService = new this.google.maps.MaxZoomService();

      // Direction
      this.directionsService = new this.google.maps.DirectionsService();
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition(position => {
        this.$mePosition = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },

    runSnapToRoad (path) {
      var pathValues = [];
      for (var i = 0; i < path.length; i++) {
        var x = (path[i].lat.toFixed(6) + ',' + path[i].lng.toFixed(6));
        pathValues.push(x);
        console.log(x);
      }

      snapToRoads(this.apiKey, pathValues)
        .then((response) => {
          this.processSnapToRoadResponse(response.data)
          this.drawSnappedPolyline()
        })
        .catch((error) => {
          console.log(error)
        })
    },

    processSnapToRoadResponse (data) {
      this.snappedCoordinates = [];
      this.placeIdArray = [];
      for (let i = 0; i < data.snappedPoints.length; i++) {
        let latlng = new this.google.maps.LatLng(
          data.snappedPoints[i].location.latitude,
          data.snappedPoints[i].location.longitude);
        this.snappedCoordinates.push(latlng);
        this.placeIdArray.push(data.snappedPoints[i].placeId);
      }
    },

    drawSnappedPolyline () {
      let snappedPolyline = new this.google.maps.Polyline({
        path: this.snappedCoordinates,
        strokeColor: '#90c0f0',
        strokeWeight: 3
      });

      snappedPolyline.setMap(this.map);
      this.polylines.push(snappedPolyline);
    },

    loadReboques () {
      if (!Array.isArray(this.reboques) || this.reboques.length === 0) {
        return
      }

      let lastMarker

      this.reboques.forEach((reboque, index) => {
        /**
         * TODO: Verificar se reboque já está instanciado no mapa (Marker).
         * Isto pode ter erro se recarregar reboques e tentar instanciar um reboque
         * já instanciado, gerando duplicidade.
         */

        if (!reboque.ultimaLocalizacao) {
          return
        }

        let ico = {
          url: 'https://www.sistemarebocar.com.br/static/reboque.svg',
          scaledSize: new this.google.maps.Size(50, 50),
          origin: new this.google.maps.Point(0, 0),
          anchor: new this.google.maps.Point(0, 0)
        };

        let localizacao = {
          lat: Number(reboque.ultimaLocalizacao.lat),
          lng: Number(reboque.ultimaLocalizacao.lng)
        }

        let marker = lastMarker = new this.google.maps.Marker({
          position: localizacao,
          map: this.map,
          title: reboque.nome + ' ' + reboque.descricao,
          icon: ico
        });
        //console.log(position);
        marker.setMap(this.map);
        this.reboquesDisponiveis.push({...reboque, marker: marker})
      })

      if (this.reboques.length === 1) {
        this.maxZoomService.getMaxZoomAtLatLng(lastMarker.position, (response) => {
          if (response.status !== 'OK') {
            this.map.setZoom(11)
          } else {
            this.map.setZoom(response.zoom - 5)
          }
          this.map.panTo(lastMarker.position)
        });
        window.setTimeout(() => {
          this.map.panTo(lastMarker.position)
        }, 1000)
      }
    },

    moveReboque (reboque) {
      let reboqueInstanciado = this.reboquesDisponiveis.filter(r => r.id === reboque.reboque)
      if (!Array.isArray(reboqueInstanciado) || reboqueInstanciado.length === 0) {
        console.error('Impossível atualizar localização de reboque. Reboque não instanciado no mapa.')
        return
      }
      reboqueInstanciado = reboqueInstanciado[0]
      // reboqueInstanciado.marker.setPosition(reboque.localizacao)
      // reboqueInstanciado.marker.setMap(this.map)
      let origin = reboqueInstanciado.marker.position.toJSON()
      this.transition(origin, reboque.localizacao, reboqueInstanciado.marker)
      // this.map.panTo(reboqueInstanciado.marker.position) // Temporário
    },

    removeGhosts () {
      if (Array.isArray(this.reboquesDisponiveis) && this.reboquesDisponiveis.length > 0) {
        this.reboquesDisponiveis.forEach((reboque, index) => {
          if (reboque.working) {
            return
          }
          this.reboquesDisponiveis[index].marker.setMap(null)
          delete this.reboquesDisponiveis[index]
        })
      }
    },

    montaRotaAtendimento (solicitacao, origin, destiny, extras = null) {
      this.directionsService.route(
        {
          origin: origin,
          destination: destiny,
          travelMode: 'DRIVING'
        },
        (response, status) => {
          console.log(response, status)
          if (status === 'OK') {
            let route = {id: null, rota: response}
            saveRoute(solicitacao, {rota: response, tipo: 0, ativo: true})
              .then((response) => {
                console.log('Rota salva com sucesso')
                route.id = response.data.id
                this.renderRoute(route)
              })
              .catch((response) => {
                console.log(response.data)
                window.alert('Ocorreu algum problema ao salvar a rota, tente novamente, se o erro persistir, contate o administrador do sistema'); // TODO: Verificar/Implementar nova tentativa. Verificar melhor maneira
              })
          } else {
            window.alert('Directions request failed due to ' + status);
          }
        });

      /**
       * Tenta montar rotas complementares (DESTINATION até Patio)
       */
      if (extras && Array.isArray(extras)) {
        let _origin = origin
        extras.forEach((latLng, i) => {
          this.directionsService.route(
            {
              origin: _origin,
              destination: latLng,
              travelMode: 'DRIVING'
            },
            (response, status) => {
              if (status === 'OK') {
                // console.log(response)
                let route = {id: null, rota: response}
                saveRoute(solicitacao, {rota: response, tipo: i + 1, ativo: false})
                  .then((response) => {
                    console.log(`Rota complementar ${i + 1} salva com sucesso`)
                    route.id = response.data.id
                    // this.renderRoute(route)
                  })
                  .catch((response) => {
                    console.log(response.data)
                    window.alert('Ocorreu algum problema ao salvar a rota complementar (' + i + ').'); // TODO: Verificar/Implementar nova tentativa. Verificar melhor maneira
                  })
              } else {
                console.error('Directions c-' + i + ' request failed due to ' + status);
              }
            });
          _origin = latLng
        })
      }
    },

    renderRoute (route) {
      let find = this.activeRoutes.filter((r) => r.id === route.id)
      if (find.length > 0) {
        console.log(`Route ${route.id} já renderizada`)
        return
      }
      route.render = new this.google.maps.DirectionsRenderer();
      route.render.setMap(this.map)
      route.render.setDirections(route.rota);
      route.$checkStatus = setInterval(() => {
        checkRouteStatus(route.id)
          .then((response) => {
            if (!response.data.ativo) {
              // Remove route from map
              this.deleteRoute(route)
            }
          })
          .catch((response) => {
            if (!response.data.ativo) {
              // Remove route from map
              this.deleteRoute(route)
            }
          })
      }, 10000)
      this.activeRoutes.push(route)
    },

    deleteRoute (route) {
      route.render.setMap(null)
      route.$checkStatus && clearInterval(route.$checkStatus)
      this.activeRoutes.splice(this.activeRoutes.indexOf(route), 1);
    },

    // TODO: Move to external
    transition (origin, dest, marker) {
      console.log('MOVE: ', origin, dest)
      transitionIndex = 0;
      deltaLat = (dest.lat - origin.lat) / numDeltas;
      deltaLng = (dest.lng - origin.lng) / numDeltas;
      this.moveMarker(origin, marker);
    },

    moveMarker (origin, marker) {

      origin.lat += deltaLat;
      origin.lng += deltaLng;
      let latlng = new this.google.maps.LatLng(origin.lat, origin.lng);
      // marker.setTitle('Latitude:' + origin[0] + ' | Longitude:' + origin[1]);
      marker.setPosition(latlng);
      if (transitionIndex != numDeltas) {
        transitionIndex++;
        setTimeout(() => {
          this.moveMarker(origin, marker)
        }, delay);
      }
    }
  }
}
</script>

<template>
  <div class="h-full flex col-grow">
    <div class="google-map" style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0"
         ref="googleMap"></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
          :google="google"
          :map="map"
      />
    </template>
  </div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// CallCenterMap.vue?df2e998e